import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-notepad",
  "use": "icon-notepad-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-notepad\"><defs><style type=\"text/css\"></style></defs><path d=\"M468.53 692.6L237.1 786.92l101.6-224.14z\" fill=\"#ffffff\" p-id=\"5109\" /><path d=\"M101.64 234.99v692.92h736.22V545.48H773.7v318.26H165.81V255.95H641.2L373.61 524.18l130.61 130.61 423.95-424.95L797.56 99.23l-92.34 92.56h-603.4V235h-0.18z m362.48 289.19l333.44-334.44 40.1 40.1-333.43 334.44-40.11-40.1z\" fill=\"#ffffff\" p-id=\"5110\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/notepad.svg
// module id = LUUJ
// module chunks = 29